import React from "react";
import "../../styles/Admin.css";
import "../../styles/global.css";

const LoadingState = ({ message = "Loading..." }) => {
  return (
    <div className="admin-loading">
      <div>
        <div className="spinner" style={{ margin: "auto" }} />
        <p className="text-muted" style={{ marginTop: 16 }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingState;
